module.exports = __webpack_public_path__ + "Roboto-Regular.ba3dcd8903e3d0af5de7.woff";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Regular.woff
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Regular.woff
// module chunks = styles